<template>
  <div
    data-qa="analysis_price"
    class="d-flex align-center"
    :class="{
      'justify-end': !isMobile,
    }"
  >
    <div
      data-qa="analysis_price_discount"
      class="text-success--text text-subtitle-1 mr-1"
    >
      {{ getFormattedPrice(price_with_discount) }}
    </div>
    <div
      data-qa="analysis_price_original"
      class="text-body-2 text-secondary--text text-decoration-line-through"
    >
      {{ getFormattedPrice(price) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import getFormattedPrice from 'www/utils/get/getFormattedPrice'

const isMobile = window.MOBILE_VERSION

defineProps<{
  price: number
  price_with_discount: number // eslint-disable-line
}>()
</script>
